"use client";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Box,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import PageHeader1 from "../../components/common/PageHeader1";
import toast, { Toaster } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { fetchOffers, deleteOffer } from "../../Redux/Reducers/AddOfferReducer";
import { usePermissions } from "../../context/AuthContext";

const ListOffer = () => {
  const { can } = usePermissions();
  const [filterModel, setFilterModel] = useState({
    items: [],
    quickFilterExcludeHiddenColumns: true,
    quickFilterValues: [''],
  });
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const dispatch = useDispatch();
  const { status } = useSelector((state) => state.AddOfferReducer || {});
  const ListOffers = useSelector((state) => state.AddOfferReducer.offers || []);
  const pagination = useSelector((state) => state?.AddOfferReducer?.pagination || {});
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({});
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedOfferId, setSelectedOfferId] = useState(null);

  useEffect(() => {
    const { page, pageSize } = paginationModel;
    dispatch(fetchOffers({ page: page + 1, limit: pageSize }));
  }, [paginationModel, dispatch]);

  const handleClickOpen = (offerId) => {
    setSelectedOfferId(offerId);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedOfferId(null);
  };

  const handleDelete = () => {
    setLoading(true);
    dispatch(deleteOffer(selectedOfferId))
      .unwrap()
      .then(() => {
        toast.success("Offer deleted successfully!");
        const { page, pageSize } = paginationModel;
        dispatch(fetchOffers({ page: page + 1, limit: pageSize }));
      })
      .catch((err) => {
        toast.error(`Error: ${err}`);
      })
      .finally(() => {
        setLoading(false);
        handleClose();
      });
  };

  const rows = ListOffers?.map((offer, index) => ({
    sono: paginationModel.page * paginationModel.pageSize + index + 1,
    id: offer._id,
    offerTitle: offer.offerTitle,
    discountType: offer.discountType,
    applicableValue: offer.applicableValue,
    createdAt: offer?.createdAt
      ? new Date(offer?.createdAt).toLocaleString()
      : "",
    updatedAt: offer?.updatedAt
      ? new Date(offer?.updatedAt).toLocaleString()
      : "",
  })) || [];

  const columns = [
    { field: "sono", headerName: "S.No", width: 250 },
    { field: "offerTitle", headerName: "Offer Name", width: 250 },
    { field: "discountType", headerName: "Discount Type", width: 150 },
    { field: "applicableValue", headerName: "Value", width: 150 },
    { field: "createdAt", headerName: "Created At", width: 200 },
    { field: "updatedAt", headerName: "Updated At", width: 200 },
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      renderCell: ({ row }) => (
        <div>
          {can('offers:edit') && (
            <Tooltip title="Edit Offer">
              <IconButton component={Link} to={`/offer-edit/${row?.id}`}>
                <i className="icofont-edit text-info"></i>
              </IconButton>
            </Tooltip>
          )}
          {can('offers:delete') && (
            <Tooltip title="Delete Offer">
              <IconButton component="button" onClick={() => handleClickOpen(row?.id)}>
                <i className="icofont-ui-delete text-danger"></i>
              </IconButton>
            </Tooltip>
          )}
        </div>
      ),
    },
  ];

  return (
    <div className="body d-flex py-1">
      <Toaster />
      <div className="container-xxl">
        <PageHeader1
          righttitle="Add Offer"
          link="/offer-add"
          routebutton={can('offers:add')}
          pagetitle='Offer List'
        />
        <div className="row g-0 mb-3">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                <Box sx={{ width: 1 }}>
                  <Box sx={{ height: 400, display: "flex", justifyContent: "center", alignItems: "center" }}>
                    {status === "loading" ? (
                      <CircularProgress />
                    ) : (
                      <DataGrid
                        columns={columns}
                        rows={rows}
                        getRowId={(row) => row.id}
                        disableColumnFilter
                        disableDensitySelector
                        slots={{ toolbar: GridToolbar }}
                        filterModel={filterModel}
                        onFilterModelChange={(newModel) => setFilterModel(newModel)}
                        slotProps={{ toolbar: { showQuickFilter: true } }}
                        columnVisibilityModel={columnVisibilityModel}
                        onColumnVisibilityModelChange={(newModel) =>
                          setColumnVisibilityModel(newModel)
                        }
                        paginationMode="server"
                        rowCount={pagination?.totalDocs || 0}
                        pageSizeOptions={[10, 25, 50, 100]}
                        paginationModel={paginationModel}
                        onPaginationModelChange={setPaginationModel}
                        disableRowSelectionOnClick
                      />
                    )}
                  </Box>
                </Box>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">{"Delete Confirmation"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this offer?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDelete} color="error" autoFocus disabled={loading}>
            {loading ? <CircularProgress size={20} /> : "Delete"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ListOffer;